import axios from 'axios';
import { Aerator } from 'views/self-service/features/aerators/types/aerators.type';
import { CreateAeratorInput } from 'views/self-service/features/aerators/types/create-aerator-input.type';

// POST Aerator
// /ewosapi/v1/shrimps/aerators/{globalCompanyId}
export const postAerator = async (globalCompanyId: string, request: CreateAeratorInput) => {
  const res = await axios.post<Aerator>(`/ewosapi/v1/shrimps/aerator/${globalCompanyId}`, request);
  return res.data;
};
